import { render, staticRenderFns } from "./PessoaIdosa.vue?vue&type=template&id=321ca3a7"
import script from "./PessoaIdosa.vue?vue&type=script&lang=js"
export * from "./PessoaIdosa.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports